import React from "react";
import { NumeroWa } from "../../../services/v2/prospects.service";
import { telefonoBonito } from "../../../utils/telefonoBonito";
import "./plantelSelect.css";

const DEPTS: { [k: string]: string } = { ventas: "Ventas", admisiones: "Admisiones", caja: "Caja y Cobros", kits: "Kits", academico: "Académico", rrhh: "RRHH" };

/**
 * Filtro "Número" de WappChat, solo para Super Admin (Esteban, 2026-10-22: "agrega un filtro por canal / departamento").
 * El valor es "" (todos), "d:<dept>" (todos los números de ese departamento) o "c:<id>" (un número). El servidor filtra por
 * el último número por el que se habló con la persona.
 */
export const idsDeNumero = (numeros: NumeroWa[] | null | undefined, valor: string): number[] => {
	if (!numeros || !valor) return [];
	if (valor.startsWith("c:")) return [Number(valor.slice(2))];
	const d = valor.slice(2);
	return numeros.filter((n) => n.dept === d).map((n) => n.id);
};

const NumeroSelect: React.FC<{ numeros?: NumeroWa[] | null; value: string; onChange: (v: string) => void; className?: string }> = ({ numeros, value, onChange, className }) => {
	if (!numeros || !numeros.length) return null;
	const depts = Object.keys(DEPTS).filter((d) => numeros.some((n) => n.dept === d));
	return (
		<select className={"wl-sel plantel-sel numero-sel" + (value ? " on" : "") + (className ? " " + className : "")} value={value} aria-label="Número"
			onChange={(e) => onChange(e.target.value)}>
			<option value="">Todos los números</option>
			{depts.map((d) => (
				<optgroup key={d} label={DEPTS[d]}>
					{depts.length > 1 || numeros.length > 1 ? <option value={"d:" + d}>{"Todo " + DEPTS[d]}</option> : null}
					{numeros.filter((n) => n.dept === d).map((n) => (
						<option key={n.id} value={"c:" + n.id}>{n.label + (n.phone ? " · " + telefonoBonito(n.phone.replace(/[^\d+]/g, "")) : "")}</option>
					))}
				</optgroup>
			))}
		</select>
	);
};

export default NumeroSelect;
